import { InputBase } from '@mui/material';
import { useState } from 'react';
import { titleSx } from '../styles';

interface EditableTitleProps {
  value: string;
  onChange: (value: string) => void;
}

export const EditableTitle = ({ value, onChange }: EditableTitleProps) => {
  const [valueOnFocus, setValueOnFocus] = useState(value);

  return (
    <InputBase
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onFocus={() => setValueOnFocus(value)}
      onBlur={() => {
        if (!value.trim()) onChange(valueOnFocus);
      }}
      onKeyDown={(event) => {
        if (event.key !== 'Enter') return;

        event.preventDefault();
        (event.target as HTMLElement).blur();
      }}
      multiline
      fullWidth
      inputProps={{ 'aria-label': 'Title' }}
      sx={{ ...titleSx, p: 0, '& textarea': { p: 0 } }}
    />
  );
};
